import React, { useEffect, useRef, useState } from "react"
import { useForm } from "react-hook-form";
import Body from "../../components/body/BodyPage"
import MainLinks from "../../components/navlinks/MainLinks"
import { useTranslation } from "react-i18next";
import { useAdminContext } from "../../components/adminstore/Admin-Context";
import { MDBCol, MDBInput, MDBRow, MDBScrollspy, MDBScrollspyLink, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane, MDBAlert, MDBSpinner, MDBBtn } from "mdb-react-ui-kit";
import MultiFactorAuth from "../../components/topviews/accountsettings/MultiFactorAuth";
import { getAllSecurityDesktopInfo, getSecurityInfo, UpdateAccPinCID } from "../../apiclients/streamsapi_bridge";
import SaveChanges from "../../components/topviews/saveCancel";
import TopSuccess from "../../components/header/TopSuccess";
import TopMessage from "../../components/header/TopMessage";
import TrustedIPAddressRange from "./securitymanager/TrustedIPAddressRange";
import DeviceToTrustUsers from "./securitymanager/DeviceToTrustUsers";
import TrustedDevice from "./securitymanager/TrustedDevice";
import PendingUserDevice from "./securitymanager/PendingUserDevice";
import AuthorizedUserDevice from "./securitymanager/AuthorizedUserDevice";
import BlockedUser from "./securitymanager/BlockedUser";
import { useNavigate } from "react-router";
import TabIDConstant from "../../apiclients/TabIDConstant";


function SecurityLanding() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const { isEdited, setEdited } = useAdminContext();

    const [basicActive, setBasicActive] = useState('tab1');

    const [rerender, setrerender] = useState(true);
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };

    const { register, handleSubmit, setError, clearErrors, reset, formState: { dirtyFields, isDirty, errors } } = useForm({
        defaultValues: {
            global_settings: {
                security: {
                    mfa_login: false,
                    pin: 0
                }
            }
        }
    });


    async function getAccPinAndCidDtls() {
        try {
            setIsloading(true);
            setInternalError(false);
            const response = await getSecurityInfo(JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            TabIDConstant.SECURITY_SETT_SUBLINK
        );
            const rawData = await response.json();
            console.log("getAccPinAndCidDtls details :::::: " + JSON.stringify(rawData));
            if (response.status === 200) {
                reset({
                    mfa_login: rawData?.global_settings?.security.mfa_login ?? false,
                    pin: rawData?.global_settings.security.pin ?? 0
                })

                console.log(`rawData?.security_settings?.pin is ::: ${rawData?.security_settings?.pin}`);

            } else if (response.status === 500) {
                setInternalError(true);
            } else {
                setInternalError(true);
            }
        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
        } finally {
            setIsloading(false);
        }
    }
    useEffect(() => {
        if (rerender) {
            getAccPinAndCidDtls();
            setrerender(false);
        }

    }, [rerender]);
    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);


    function closeSave(e) {
        console.log(`isDirty value is :::::: on close ${isDirty}`);
        reset();
    }


    const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

    useEffect(() => {
        setEdited(isSave);
    }, [isSave]);

    const onSubmit = async (data) => {
        if (isDirty) {
            const modifiedData = {};
            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    modifiedData[field] = data[field];
                }

            }

            console.log("modified daata :::::::::::::" + JSON.stringify(modifiedData))

            let update = {}
            console.log(``);
            if (Object.keys(modifiedData)?.length > 0) {
                update = {
                    reqid: 64,
                    siteid: JSON.parse(
                        sessionStorage.getItem("admin_session")
                    ).siteid,
                    global_settings: {
                        security: modifiedData

                    }
                }
            }

            console.log("update vocemail operator team ::::: " + JSON.stringify(update));
            let saverep = await UpdateAccPinCID(update);
            console.log("vocemail operator:::::: " + saverep);
            let saverepeMsg = await saverep.json();
            console.log("response vocemail operator::::: " + JSON.stringify(saverepeMsg))

            if (saverepeMsg.status && saverepeMsg.status == "success") {
                setSuccessMessage(saverepeMsg.message);
                setrerender(true);

            }
            else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {

                        if (err.param_name === "global_settings.security.pin") {
                            setError(err.param_name, { message: err.message })
                            console.log("errorrr::::::::::" + err)
                            console.log("errrmsg::::::::::" + err.message)

                            // reset();
                        }
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        console.log("fieldelemnet", fieldElement)
                        if (fieldElement) {
                            fieldElement.focus();

                        }
                    });
                }

            }

        }
    }

    const section1 = useRef(null);
    const section2 = useRef(null);

    const containerRef = useRef(null);


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const scrollspyLinks = document.querySelectorAll(".nav-link");
            const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
            const stickyParent = lastLink.closest(".sticky-top");
            if (stickyParent && lastLink.classList.contains("active")) {
                lastLink.classList.remove("active");
                for (let i = 0; i < scrollspyLinks.length; i++) {
                    const firstLink = scrollspyLinks[i];
                    const parent = firstLink.closest(".sticky-top");
                    if (parent) {
                        firstLink.classList.add("active");
                        break;
                    }
                }
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);



    const navigate = useNavigate();
    const [status2, setStatus2] = useState('Pending');
    const [updatesuccessMessage, setUpdateSuccessMessage] = useState("");
    const [trustedIPS, settrustedIPS] = useState([]);
    const [pendingUsers, setpendingUsers] = useState([]);
    const [authorixedUser, setauthorixedUser] = useState([]);
    const [blockedUsers, setblockedUsers] = useState([]);
    const [devicesToTrust, setdevicesToTrust] = useState([]);
    const [trustedDevices, settrustedDevices] = useState([]);













    useEffect(() => {
        if (updatesuccessMessage) {
            setTimeout(() => {
                setUpdateSuccessMessage("");
            }, 5000);
        }
    }, [updatesuccessMessage]);


    return (
        <React.Fragment>
            <>
                <MainLinks active={6} />
                <Body
                    tablinks={6}
                    sublink={271}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            {t("security")}
                                        </h5>
                                    </div>
                                    <MDBTabs className='mb-3'>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                Settings
                                            </MDBTabsLink>
                                        </MDBTabsItem>

                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                Trusted IP Address Range
                                            </MDBTabsLink>
                                        </MDBTabsItem>


                                        {/* <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                                                Select the Device(s) to Trust for ALL Users
                                            </MDBTabsLink>
                                        </MDBTabsItem>

                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab4')} active={basicActive === 'tab4'}>
                                                Trusted Device(s)
                                            </MDBTabsLink>
                                        </MDBTabsItem>

                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab5')} active={basicActive === 'tab5'}>
                                                Pending User(s) on Device(s)
                                            </MDBTabsLink>
                                        </MDBTabsItem>

                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab6')} active={basicActive === 'tab6'}>
                                                Authorized User(s) on Device(s)
                                            </MDBTabsLink>
                                        </MDBTabsItem>

                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab7')} active={basicActive === 'tab7'}>
                                                Blocked User(s)
                                            </MDBTabsLink>
                                        </MDBTabsItem> */}



                                    </MDBTabs>

                                    <MDBTabsContent>
                                        <MDBTabsPane open={basicActive === 'tab1'}>
                                            <MDBRow>
                                                <MDBCol
                                                    size="2"
                                                    md="2"
                                                    lg="2"
                                                    sm="12"
                                                    className="col-sm-100 pr-0 leftTabs"
                                                >
                                                    <MDBScrollspy container={containerRef}>
                                                        <MDBScrollspyLink targetRef={section1}>
                                                            MFA For Every Login
                                                        </MDBScrollspyLink>
                                                        <MDBScrollspyLink targetRef={section2}>
                                                            Account PIN
                                                        </MDBScrollspyLink>
                                                    </MDBScrollspy>
                                                </MDBCol>

                                                <MDBCol
                                                    size="12"
                                                    md="10"
                                                    sm="12"
                                                    pr-0
                                                    className="col-sm-100 pr-0 leftTabContent"
                                                >
                                                    <div ref={containerRef} className="scrollspy-example" style={{ maxHeight: "100vh !important" }}>
                                                        <section ref={section1} id="section-1">
                                                            <div class="general-settings mt-4">MFA</div>
                                                            <MultiFactorAuth
                                                                register={register}
                                                                errors={errors}
                                                            />
                                                        </section>
                                                        <div className="routing-border"></div>
                                                        <section ref={section2} id="section-2">
                                                            <div class="general-settings mt-4">Account PIN</div>
                                                            <div className="add-numbermain mt-0" >
                                                                <div>
                                                                    <label>Account PIN</label><br />
                                                                    <span className="phrecording">
                                                                        Used for Billing and Support purposes
                                                                    </span>
                                                                </div>
                                                                <div className="w-200px" >
                                                                    <MDBInput
                                                                        className="w-100"
                                                                        type="number"
                                                                        {...register('pin', {
                                                                            required: "PIN is required",
                                                                            setValueAs: (value) => value === "" ? null : parseInt(value, 10)
                                                                        })}

                                                                    />
                                                                    {errors.global_settings?.security.pin && (

                                                                        <p className="text-danger">{errors.global_settings?.security.pin.message}</p>


                                                                    )}
                                                                </div>
                                                            </div>
                                                        </section>

                                                        {isDirty && (
                                                            <SaveChanges
                                                                onClose={closeSave}
                                                                onSave={(e) => {
                                                                    e.preventDefault();
                                                                    handleSubmit(onSubmit)();
                                                                }}
                                                            />
                                                        )}

                                                        {internalError && (
                                                            <MDBAlert
                                                                open
                                                                className="alert-center"
                                                                color="danger"
                                                                autohide
                                                                position="bottom-right"
                                                                delay={5000}
                                                                onClose={() => setInternalError(false)}
                                                            >
                                                                Internal Server Error
                                                            </MDBAlert>
                                                        )}

                                                        {successMessage && (
                                                            <>
                                                                <TopSuccess>
                                                                    <TopMessage successMessage={successMessage} />
                                                                </TopSuccess>
                                                            </>
                                                        )}

                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBTabsPane>

                                        <MDBTabsPane open={basicActive === 'tab2'}>
                                            <TrustedIPAddressRange
                                                isActive={basicActive === 'tab2'}
                                            />
                                        </MDBTabsPane>

                                        {/* <MDBTabsPane open={basicActive === 'tab3'}>
                                            <DeviceToTrustUsers
                                                devicesToTrust={devicesToTrust} />
                                        </MDBTabsPane>

                                        <MDBTabsPane open={basicActive === "tab4"}>
                                            <TrustedDevice
                                                trustedDevices={trustedDevices}
                                            />
                                        </MDBTabsPane>

                                        <MDBTabsPane open={basicActive === "tab5"}>
                                            <PendingUserDevice
                                                pendingUsers={pendingUsers}
                                            />
                                        </MDBTabsPane>


                                        <MDBTabsPane open={basicActive === "tab6"}>
                                            <AuthorizedUserDevice
                                                authorixedUser={authorixedUser}
                                            />
                                        </MDBTabsPane>

                                        <MDBTabsPane open={basicActive === "tab7"}>
                                            <BlockedUser
                                                blockedUsers={blockedUsers}
                                            />
                                        </MDBTabsPane> */}

                                    </MDBTabsContent>
                                </div>
                            </section>


{isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}

                        </>
                    }
                />


            </>
        </React.Fragment>
    )
}

export default SecurityLanding
